import { ChakraProvider } from '@chakra-ui/react';
import Designer from './components/Designer';
import { DesignerContextProvider } from './lib/designerContext';
import { FontContextProvider } from './lib/fontContext';

// for the context of "data" it contains the prices for each size, 
// for example, a design with A3 size (30x40 cm) has a price of Rp 45,000.
import { data } from './data';

function App() {
  return (
    <ChakraProvider>
      <DesignerContextProvider>
        <FontContextProvider>
          <Designer
            errors={{}}
            {...data}
          />
        </FontContextProvider>
      </DesignerContextProvider>
    </ChakraProvider>
  );
}

export default App;
